type ClientIdentity = {
  id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  companyName?: string;
  applicationType?: string;
};

const BUSINESS_TYPES = new Set(['BUSINESS', 'LEGAL', 'COMPANY', 'CORPORATE']);
const PRIVATE_TYPES = new Set(['PRIVATE', 'PERSONAL', 'INDIVIDUAL']);

const clean = (value?: string | null): string => (value || '').trim();

export const getClientPersonName = (client?: Pick<ClientIdentity, 'firstName' | 'lastName'> | null): string => {
  if (!client) return '';
  return [clean(client.firstName), clean(client.lastName)].filter(Boolean).join(' ').trim();
};

export const getClientDisplayName = (client?: ClientIdentity | null): string => {
  if (!client) return '';

  const companyName = clean(client.companyName);
  const personName = getClientPersonName(client);
  const email = clean(client.email);
  const fullName = clean(client.fullName);
  const appType = clean(client.applicationType).toUpperCase();

  if (BUSINESS_TYPES.has(appType)) {
    return companyName || personName || email || fullName || clean(client.id);
  }

  if (PRIVATE_TYPES.has(appType)) {
    return personName || companyName || email || fullName || clean(client.id);
  }

  if (companyName) return companyName;
  return personName || email || fullName || clean(client.id);
};

export const getClientOptionLabel = (client?: ClientIdentity | null): string => {
  if (!client) return '';
  const displayName = getClientDisplayName(client);
  const email = clean(client.email);
  if (!displayName) return email || clean(client.id);
  if (!email || email.toLowerCase() === displayName.toLowerCase()) return displayName;
  return `${displayName} (${email})`;
};
